import { Component } from 'react'
import cn from 'classnames'
import s from './TableContainer.scss'
import '!style-loader!css-loader!ag-grid-community/dist/styles/ag-grid.css' // eslint-disable-line
import '!style-loader!css-loader!ag-grid-community/dist/styles/ag-theme-balham.css' // eslint-disable-line
import '!style-loader!css-loader!styles/overrides/ag-grid.css' // eslint-disable-line
import { Button } from 'reactstrap'
import { FaFileExcel, FaRegSave, FaTrashAlt } from 'react-icons/fa'
import { If } from 'components/ideal-core-ui'
import { TableViewModal } from './TableViewModal'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { getUser } from 'utils/authService'
import swal from 'sweetalert'
import Select from 'react-select'
import { toGroupOptions } from './serializers'
import * as ACT from './actions'
import { TABLE_PAGE_SIZE, TABLE_ROW_SERVER_SIDE_MODEL } from 'utils/constants'
import { makeReportsPostRequest } from 'utils/api'
import { AddButton } from 'components/common/AddButton'
import { serializeNullToEmptyString } from 'utils/helpers'

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}

const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center'
}

const excelStyles = [
  {
    id: 'header',
    interior: {
      color: '#f5f7f7',
      pattern: 'Solid'
    },
    font: {
      color: '#434343',
      size: 11
    },
    borders: {
      borderBottom: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      },
      borderLeft: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      },
      borderRight: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      },
      borderTop: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      }
    }
  },
  {
    id: 'oddRow',
    interior: {
      color: '#ffffff',
      pattern: 'Solid'
    },
    font: {
      color: '#434343',
      size: 9
    },
    borders: {
      borderBottom: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      },
      borderLeft: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      },
      borderRight: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      },
      borderTop: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      }
    }
  },
  {
    id: 'evenRow',
    interior: {
      color: '#fcfdfe',
      pattern: 'Solid'
    },
    font: {
      color: '#434343',
      size: 9
    },
    borders: {
      borderBottom: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      },
      borderLeft: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      },
      borderRight: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      },
      borderTop: {
        color: '#bdc3c7',
        lineStyle: 'Continuous',
        weight: 1
      }
    }
  }
]

const isFirstColumn = params => {
  var displayedColumns = params.columnApi.getAllDisplayedColumns()
  var thisIsFirstColumn = displayedColumns[0] === params.column

  return thisIsFirstColumn
}

@connect(({ users }) => {
  return {
    tableView: users.tableView,
    tableViewList: users.tableViewList
  }
})
class TableContainer extends Component {
  constructor(props) {
    super(props)
    this.saveViewAsList = this.saveViewAsList.bind(this)
    this.dataSource = {
      getRows: async params => {
        try {
          // get data for request from server
          const response = await makeReportsPostRequest(this.props.fetchUrl, {
            ...params.request,
            userId: this.props.filteredByUserId
          })
          // supply rows for requested block to grid
          params.success({
            rowData: serializeNullToEmptyString(response.data),
            rowCount: response.lastRow
          })
        } catch (e) {
          // inform grid request failed
          params.fail()
        }
      }
    }
  }

  componentDidMount() {
    if (this.props.canSaveAsList) {
      this.getTableViews()
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (!isEmpty(this.props.tableView) || !isEmpty(prevProps.tableView)) &&
      this.props.tableView !== prevProps.tableView
    ) {
      this.restoreViewFromList()
    }
    if (
      this.props.filteredByUserId !== prevProps.filteredByUserId &&
      this.props.rowModelType === TABLE_ROW_SERVER_SIDE_MODEL
    ) {
      this.gridApi && this.gridApi.refreshServerSideStore()
    }
  }

  defaultColDef = {
    sortable: true,
    ...(this.props.rowModelType !== TABLE_ROW_SERVER_SIDE_MODEL
      ? { filter: 'agSetColumnFilter' }
      : {}),
    resizable: true,
    autoHeight: true,
    enableRowGroup: true,
    headerClass: 'header',
    cellClassRules: {
      oddRow: params => params.rowIndex % 2 === 0,
      evenRow: params => params.rowIndex % 2 === 1
    },
    ...(this.props.selectable
      ? {
          headerCheckboxSelection:
            this.props.rowModelType !== TABLE_ROW_SERVER_SIDE_MODEL ? isFirstColumn : () => false,
          checkboxSelection: isFirstColumn,
          headerCheckboxSelectionFilteredOnly: true
        }
      : {})
  }

  onRowDataChanged = params => {
    this.columnApi = params.columnApi
    this.gridApi = params.api
  }

  onGridReady = params => {
    this.props.rowModelType !== TABLE_ROW_SERVER_SIDE_MODEL &&
      params.columnApi.applyColumnState(this.props.defaultSortModel)

    if (this.props.rowModelType === TABLE_ROW_SERVER_SIDE_MODEL) {
      params.api.setServerSideDatasource(this.dataSource)
    }
  }

  paginationChanged = params => {
    if (params.newPage) {
      this.props.rowModelType !== TABLE_ROW_SERVER_SIDE_MODEL &&
        params.columnApi.applyColumnState({
          state: params.columnApi.getColumnState(),
          applyOrder: true
        })
    }
  }

  onSelectionChanged = event => {
    const selectedRows = event.api.getSelectedNodes().slice(0, TABLE_PAGE_SIZE)
    this.setState({
      selectedRows
    })
    this.props.onSelectionChanged?.(selectedRows)
  }

  state = {
    defaultColDef: this.defaultColDef,
    resetRowHeights: this.resetRowHeights,
    onRowDataChanged: this.onRowDataChanged,
    onGridReady: this.onGridReady,
    headerHeight: 48,
    rowSelection: 'multiple',
    paginationPageSize: this.props.paginationPageSize || TABLE_PAGE_SIZE,
    cacheBlockSize: this.props.paginationPageSize || TABLE_PAGE_SIZE,
    pagination: true,
    serverSideStoreType: 'partial',
    rowModelType: this.props.rowModelType,
    suppressRowClickSelection: true,
    onPaginationChanged: this.paginationChanged,
    reactUi: false,
    excelStyles,
    sideBar: {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          toolPanelParams: {
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressRowGroups: false
          }
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel'
        }
      ],
      defaultToolPanel: ''
    },
    tableViewTitle: '',
    isPublic: false,
    currentList: {
      colState: '',
      sortState: '',
      filterState: ''
    },
    showTableViewModal: false,
    onSelectionChanged: this.onSelectionChanged,
    groupSelectsChildren: this.props.rowModelType !== TABLE_ROW_SERVER_SIDE_MODEL,
    selectedRows: []
  }

  onBtnExport = () => {
    this.gridApi.exportDataAsExcel({
      sheetName: 'iDeal',
      onlySelected: !!this.state.selectedRows.length
    })
  }

  saveViewAsList() {
    const { columnApi, gridApi } = this
    this.setState(
      {
        ...this.state,
        currentList: {
          colState: columnApi.getColumnState(),
          sortState: columnApi.getColumnState(),
          filterState: gridApi.getFilterModel()
        }
      },
      () => {
        const { currentList, tableViewTitle, isPublic } = this.state
        this.onSaveAsList && this.onSaveAsList(tableViewTitle, currentList, isPublic)
        this.toggleTableViewModal()
      }
    )
  }

  restoreViewFromList() {
    const { columnApi, gridApi } = this
    if (!columnApi) return
    if (isEmpty(this.props.tableView)) {
      columnApi.resetColumnState()
      this.props.rowModelType !== TABLE_ROW_SERVER_SIDE_MODEL && gridApi.setFilterModel(null)
      return
    }

    const { colState, sortState, filterState } = JSON.parse(this.props.tableView.content)

    columnApi.applyColumnState({ state: colState, applyOrder: true })
    if (this.props.rowModelType !== TABLE_ROW_SERVER_SIDE_MODEL) {
      columnApi.applyColumnState({ state: sortState, applyOrder: true })
      gridApi.setFilterModel(filterState)
    }
  }

  toggleTableViewModal = () => {
    this.setState(prevState => ({
      showTableViewModal: !prevState.showTableViewModal,
      isPublic: false,
      tableViewTitle: ''
    }))
  }

  setTableViewTitle = title => {
    this.setState({
      ...this.state,
      tableViewTitle: title
    })
  }

  setIsPublic = isPublic => {
    this.setState({
      ...this.state,
      isPublic
    })
  }

  resetTableViewModal = () => {
    this.setState({
      ...this.state,
      isPublic: false,
      tableViewTitle: ''
    })
  }

  deleteList = async () => {
    const willRemove = await swal({
      title: 'You are about to delete this view from your Saved Lists',
      text: 'Are you sure you want to continue?',
      buttons: ['No', 'Yes'],
      icon: 'warning'
    })
    if (willRemove) {
      const { title, id } = this.props.tableView
      this.onDeleteList && this.onDeleteList(title, id)
      this.resetTableViewModal()
    }
  }

  onSaveAsList = (title, view, isPublic) => {
    this.props.dispatch({
      type: ACT.TABLE_VIEWS_SAVE_REQUESTED,
      payload: {
        table: this.props.tableKey,
        title,
        view,
        isPublic
      }
    })
  }

  onDeleteList = (title, id) => {
    this.props.dispatch({
      type: ACT.TABLE_VIEW_DELETE_REQUESTED,
      payload: {
        table: this.props.tableKey,
        title,
        id
      }
    })
  }

  onSelectList = title => {
    this.props.dispatch({
      type: ACT.TABLE_VIEW_FETCH_REQUESTED,
      payload: {
        title,
        table: this.props.tableKey
      }
    })
  }

  getTableViews = () => {
    this.props.dispatch({
      type: ACT.TABLE_VIEWS_LIST_FETCH_REQUESTED,
      payload: {
        table: this.props.tableKey
      }
    })
    this.props.dispatch({
      type: ACT.TABLE_VIEWS_LIST_RESET
    })
  }

  formatGroupLabel = data => (
    <div style={groupStyles}>
      <span>{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  )

  render() {
    return (
      <>
        <div className={cn('ag-theme-balham', s.grid, this.props.className)}>
          <>
            {this.props.canSaveAsList && (
              <>
                <Button className={s.saveAsList} onClick={this.toggleTableViewModal}>
                  <FaRegSave className={s.excelIcon} />
                  Save View as List
                </Button>
                {getUser()?.id === this.props.tableView?.userId && (
                  <Button className={s.deleteList} onClick={this.deleteList}>
                    <FaTrashAlt className={s.excelIcon} />
                    Delete This List
                  </Button>
                )}
                <Select
                  onChange={value =>
                    this.onSelectList(value.value !== -1 ? value.label : value.value)
                  }
                  options={[
                    { value: -1, label: 'Default View' },
                    ...toGroupOptions(this.props.tableViewList)
                  ]}
                  formatGroupLabel={this.formatGroupLabel}
                  className={s.userSelect}
                  defaultValue={{
                    value: -1,
                    label: 'Default View'
                  }}
                  value={
                    this.props.tableView?.id
                      ? {
                          value: this.props.tableView.id,
                          label: this.props.tableView.title
                        }
                      : {
                          value: -1,
                          label: 'Default View'
                        }
                  }
                />
              </>
            )}
            {this.props.actions && this.props.actions.length > 0 && (
              <>
                {this.props.actions.map(action => {
                  if (action.condition) {
                    return action.component
                  }
                  return null
                })}
              </>
            )}
            <AddButton onClick={this.onBtnExport} className={s.exportExcel} simpleBtn>
              <FaFileExcel className={s.excelIcon} />
              Export to Excel
            </AddButton>
            <div className={s.clearfix} />
            {this.props.children(this.state)}
          </>
        </div>
        <If condition={this.state.showTableViewModal}>
          <TableViewModal
            showTableViewModal={this.state.showTableViewModal}
            toggleTableViewModal={this.toggleTableViewModal}
            saveViewAsList={this.saveViewAsList}
            setTableViewTitle={this.setTableViewTitle}
            setIsPublic={this.setIsPublic}
            tableViewTitle={this.state.tableViewTitle}
            isPublic={this.state.isPublic}
          />
        </If>
      </>
    )
  }
}

TableContainer.defaultProps = {
  defaultSortModel: [
    {
      colId: 'createdAt',
      sort: 'desc'
    }
  ],
  canSaveAsList: false
}

export default TableContainer
